<section>
    <div class="header">
        <h2>Modificar tamaño contrato</h2>
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="modal-body">
        <form class="form-section" [formGroup]="formGroup" (ngSubmit)="submit()">
            <mat-form-field class="contract-amount-input">
                <mat-label>Tamaño contrato</mat-label>
                <input matInput formControlName="contractAmount" mask="separator" thousandSeparator="." />
            </mat-form-field>
            <button [disabled]="formGroup.invalid" type="submit" style="margin-top: 10px;" mat-raised-button color="primary">Actualizar</button>
        </form>
    </div>
</section>
